import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
  useContext,
} from "react";
import axios from "axios";
import Select from "react-select";
import { useParams, Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { AppContext } from "../../../context/AppContext";
import { Box } from "@mui/material";
import { toastError, toastWarn } from "../../../common/Toast";

const OpenPurchaseOrderDetail = (props) => {
  const token = localStorage.getItem("Token");
  const locationid = localStorage.getItem("Location");
  const { CurrencySymbol, FractionDigits, dateFormate } =
    useContext(AppContext);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startdate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [enddate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);
  const [locationdropdown, setLocationDropdown] = useState([]);
  const [selectedlocationid, setSelectedLocationID] = useState(
    Number(locationid)
  );

  const handleDropdownChange = (event) => {
    // const selectedValue = event.target.value;
    setSelectReport(event?.value);
    console.log(event.target.value);
    if (event?.value == 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  const handleLocationDropdownChange = (event) => {
    setSelectedLocationID(event?.value);
    console.log(event?.value, "Location chnage");
  };

  const apicall = () => {
    setLoading(true);
    setResponseData([]);
    axios
      .get(
        `${config.reportsBaseUrl}/reports/openpurchaseorderdetail?filtercolumnsearchtext=&currentorder=&ordercolumn=&pagesize=0&pagenumber=0&filtertext=&startdate=${startdate}&enddate=${enddate}&locationid=${selectedlocationid}&currentlocationid=${locationid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          if (res.data.ResponseData.length > 0) {
            const numArr = res.data.ResponseData.map((obj) => {
              return {
                ...obj,
                BackorderedQuantity: obj.BackorderedQuantity
                  ? Number(obj.BackorderedQuantity)
                  : 0,
                TotalAmount: obj.TotalAmount ? Number(obj.TotalAmount) : 0,
                ReceivedAmount: obj.ReceivedAmount
                  ? Number(obj.ReceivedAmount)
                  : "",
                OpenBalance: obj.OpenBalance ? Number(obj.OpenBalance) : "",
                QuantityPurchased: obj.QuantityPurchased
                  ? Number(obj.QuantityPurchased)
                  : "",
              };
            });
            setResponseData(numArr);
            setLoading(false);
          } else {
            toastWarn("No Records Found!");
          }
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  // useEffect(()=>{
  //  apicall()
  // },[
  //   columnFilters,
  //   globalFilter,
  //   pagination.pageIndex,
  //   pagination.pageSize,
  //   sorting,
  //   startdate,
  //   enddate,])

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setSelectedDate(res.data.ResponseData);
        return res;
      });

    // Location Dropdown
    axios
      .get(`${config.locationBaseUrl}/locations/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLocationDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload);
    setStartDate(payload);
    setEndDate(enddate2);
  };

  const columns = useMemo(() => [
    {
      header: "Date",
      accessorKey: "Date",
      size: "100",
      Cell: ({ row }) => moment(row.original.Date).format(`${dateFormate.toUpperCase()}`),
    },
    {
      header: "Num",
      accessorKey: "Num",
      filterFn: "contains",
      size: "110",
    },
    {
      header: "Vendor",
      accessorKey: "Vendor",
      filterFn: "contains",
      size: "110",
    },
    {
      header: "Product / Service",
      accessorKey: "Product",
      filterFn: "contains",
      size: "110",
    },
    {
      header: "Account",
      accessorKey: "Account",
      filterFn: "contains",
    },
    {
      header: "QTY",
      accessorKey: "BackorderedQuantity",
      filterFn: "contains",
      size: "110",
      Cell: ({ row }) => Number(row.original.BackorderedQuantity).toFixed(2),
      AggregatedCell: ({ cell, table }) => {
        const groupingColumnId = cell.row.groupingColumnId ?? "";
        const originalValue =
          cell.row.original?.[groupingColumnId] ??
          cell.row.subRows?.[0]?.original?.[groupingColumnId];

        // Retrieve the aggregated value
        const aggregatedValue = cell.getValue();

        // Check if the value is valid and format it
        const formattedValue =
          typeof aggregatedValue === "number"
            ? CurrencySymbols(
              Number(aggregatedValue),
              { CurrencySymbol },
              FractionDigits
            )
            : "N/A"; // Fallback for non-numeric values

        return (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total for {originalValue ?? "Unknown"}:
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {formattedValue}
            </Box>
          </>
        );
      },
    },
    {
      header: "Received QTY",
      accessorKey: "QuantityPurchased",
      Cell: ({ row }) => Number(row.original.QuantityPurchased).toFixed(2),
      AggregatedCell: ({ cell, table }) => {
        const groupingColumnId = cell.row.groupingColumnId ?? "";
        const originalValue =
          cell.row.original?.[groupingColumnId] ??
          cell.row.subRows?.[0]?.original?.[groupingColumnId];

        // Retrieve the aggregated value
        const aggregatedValue = cell.getValue();

        // Check if the value is valid and format it
        const formattedValue =
          typeof aggregatedValue === "number"
            ? CurrencySymbols(
              Number(aggregatedValue),
              { CurrencySymbol },
              FractionDigits
            )
            : "N/A"; // Fallback for non-numeric values

        return (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total for {originalValue ?? "Unknown"}:
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {formattedValue}
            </Box>
          </>
        );
      },
    },
    {
      header: "Backordered QTY	",
      accessorKey: "BackorderedQuantity",
      AggregatedCell: ({ cell, table }) => {
        const groupingColumnId = cell.row.groupingColumnId ?? "";
        const originalValue =
          cell.row.original?.[groupingColumnId] ??
          cell.row.subRows?.[0]?.original?.[groupingColumnId];

        // Retrieve the aggregated value
        const aggregatedValue = cell.getValue();

        // Check if the value is valid and format it
        const formattedValue =
          typeof aggregatedValue === "number"
            ? CurrencySymbols(
              Number(aggregatedValue),
              { CurrencySymbol },
              FractionDigits
            )
            : "N/A"; // Fallback for non-numeric values

        return (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total for {originalValue ?? "Unknown"}:
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {formattedValue}
            </Box>
          </>
        );
      },
    },
    {
      header: "Total Amount",
      accessorKey: "TotalAmount",
      filterFn: "contains",
      size: "110",
      Cell: ({ row }) => {
        return (
          <div style={{ textAlign: "end" }}>
            {CurrencySymbols(
              Number(row.original.TotalAmount),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
      AggregatedCell: ({ cell, table }) => {
        const groupingColumnId = cell.row.groupingColumnId ?? "";
        const originalValue =
          cell.row.original?.[groupingColumnId] ??
          cell.row.subRows?.[0]?.original?.[groupingColumnId];

        // Retrieve the aggregated value
        const aggregatedValue = cell.getValue();

        // Check if the value is valid and format it
        const formattedValue =
          typeof aggregatedValue === "number"
            ? CurrencySymbols(
              Number(aggregatedValue),
              { CurrencySymbol },
              FractionDigits
            )
            : "N/A"; // Fallback for non-numeric values

        return (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total for {originalValue ?? "Unknown"}:
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {formattedValue}
            </Box>
          </>
        );
      },
    },
    {
      header: "Received Amount",
      accessorKey: "ReceivedAmount",
      filterFn: "contains",
      size: "110",
      enableSorting: false,
      Cell: ({ row }) => {
        return (
          <div style={{ textAlign: "end" }}>
            {CurrencySymbols(
              Number(row.original.ReceivedAmount),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
      AggregatedCell: ({ cell, table }) => {
        const groupingColumnId = cell.row.groupingColumnId ?? "";
        const originalValue =
          cell.row.original?.[groupingColumnId] ??
          cell.row.subRows?.[0]?.original?.[groupingColumnId];

        // Retrieve the aggregated value
        const aggregatedValue = cell.getValue();

        // Check if the value is valid and format it
        const formattedValue =
          typeof aggregatedValue === "number"
            ? CurrencySymbols(
              Number(aggregatedValue),
              { CurrencySymbol },
              FractionDigits
            )
            : "N/A"; // Fallback for non-numeric values

        return (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total for {originalValue ?? "Unknown"}:
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {formattedValue}
            </Box>
          </>
        );
      },
    },
    {
      header: "Open Balance",
      accessorKey: "OpenBalance",
      filtrable: false,
      Cell: ({ row }) => {
        return (
          <div style={{ textAlign: "end" }}>
            {CurrencySymbols(
              Number(row.original.OpenBalance),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
      AggregatedCell: ({ cell, table }) => {
        const groupingColumnId = cell.row.groupingColumnId ?? "";
        const originalValue =
          cell.row.original?.[groupingColumnId] ??
          cell.row.subRows?.[0]?.original?.[groupingColumnId];

        // Retrieve the aggregated value
        const aggregatedValue = cell.getValue();

        // Check if the value is valid and format it
        const formattedValue =
          typeof aggregatedValue === "number"
            ? CurrencySymbols(
              Number(aggregatedValue),
              { CurrencySymbol },
              FractionDigits
            )
            : "N/A"; // Fallback for non-numeric values

        return (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total for {originalValue ?? "Unknown"}:
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {formattedValue}
            </Box>
          </>
        );
      },
    },
    {
      header: "Rate",
      accessorKey: "CostPrice",
      Cell: ({ row }) => {
        const costPrice = row?.original?.CostPrice;
        if (costPrice == "0.00" || costPrice == "") {
          return 0.0;
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(costPrice),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
    {
      header: "Sku",
      accessorKey: "SKU",
      filterFn: "contains",
      size: "110",
      Cell: ({ row }) => (row.original?.SKU == null ? "" : row.original?.SKU),
    },
    {
      header: "Rate",
      accessorKey: "CostPrice",
      Cell: ({ row }) => {
        const costPrice = row?.original?.CostPrice;
        if (costPrice == "0.00" || costPrice == "") {
          return 0.0;
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(costPrice),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
    {
      header: "Memo/Description",
      accessorKey: "Description",
      filterFn: "contains",
    },
    {
      header: "Last Modified By",
      accessorKey: "ModifiedBy",
      filterFn: "contains",
    },
    {
      header: "Last Modified Date",
      accessorKey: "LastModified",
      size: "140",
      Cell: ({ row }) => {
        const transactionDate = moment(row.original.LastModified);
        if (transactionDate.isValid()) {
          return moment(transactionDate).format("MM/DD/YYYY hh:mm A");
        } else {
          return "";
        }
      },
    },
    {
      header: "Create Date",
      accessorKey: "CreateDate",
      size: "140",
      Cell: ({ row }) =>
        moment(row.original.CreateDate).format(`${dateFormate.toUpperCase()} hh:mm A`),
    },
    {
      header: "Created By",
      accessorKey: "CreatedBy",
      filterFn: "contains",
    },
    {
      header: "Sku",
      accessorKey: "SKU",
      filterFn: "contains",
      size: "110",
      Cell: ({ row }) => (row.original?.SKU == null ? "" : row.original?.SKU),
    },
    {
      header: "CLIENT/VENDOR MESSAGE",
      accessorKey: "VendorMessage",
      filterFn: "contains",
    },
  ]);

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  const locationDropdownOption = [
    { label: "All", value: 0 }, // Adding "All" option
    ...locationdropdown.map((u) => ({ label: u.Name, value: u.Id })),
  ];

  console.log(locationDropdownOption, "locationDropdownOption 121212121");

  const muiTableBodyRowProps = ({ row }) => ({
    // console.log(row, "checkthis");
    onClick: () => {
      window.open(`/receiving-receipt/${row.original.posID}`, "_blank");
    },
    sx: { cursor: "pointer" },
  });

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Open Purchase Order Detail
                </li>
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Report period
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    // isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={reportdropdown.find((e) => e.value === selectReport)}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-4 ">
                {/* <div className="row"> */}
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
                {/* </div> */}
              </div>
            )}
            <div className="col-sm-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Locations
              </label>
              <div className="col-md-12 z-3">
                <Select
                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  options={locationDropdownOption}
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  hideSelectedOptions={true}
                  // isClearable={true}
                  name="location"
                  id="location"
                  value={locationDropdownOption.find(
                    (e) => e.value === selectedlocationid
                  )}
                  onChange={(event) => {
                    handleLocationDropdownChange(event);
                  }}
                  className="custom-search-select"
                ></Select>
              </div>
            </div>
            <div className="col-sm-2 align-self-sm-end">
              <button
                type="submit"
                className="btn btn-primary"
                // style={{ marginLeft: "auto" }}
                onClick={() => apicall()}
              >
                Run Report
              </button>
            </div>
          </div>

          {/* Receipt */}
          {responseData.length > 0 && (
            <div className="card mt-3" id="print">
              <div className="card-body">
                <div className="container">
                  <div className="col-md-12 text-center" id="header">
                    <h6 className="P">SonarPos</h6>
                    <p className="fw-bold p-regular">
                      Open Purchase Order Detail
                    </p>
                    <div className="row mb-2">
                      <p>
                        Date:{" "}
                        {startdate === "" && enddate === ""
                          ? "All Data"
                          : moment(startdate).format(
                              `${dateFormate.toUpperCase()}`
                            ) +
                            " - " +
                            moment(enddate).format(
                              `${dateFormate.toUpperCase()}`
                            )}
                      </p>
                    </div>
                  </div>
                </div>
                <hr />

                <div>
                  <CommonMatrialReactTable
                    MainHeading="Sonar POS"
                    ReportHeading="Open Purchase Order Detail"
                    columns={columns}
                    data={responseData}
                    startdate={startdate}
                    enddate={enddate}
                    columnGrouping={["Product"]}
                    enableExpandAll={true}
                    enableExpanding={true}
                    expanded={true}
                    enableRowSelection={false}
                    columnsVisibility={{
                      SKU: false,
                      CostPrice: false,
                      VendorMessage: false,
                      CreateDate: false,
                      CreatedBy: false,
                      Description: false,
                      ModifiedBy: false,
                      LastModified: false,
                      CostPrice: false,
                    }}
                    // muiTableBodyRowProps={muiTableBodyRowProps}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default OpenPurchaseOrderDetail;
